import { createStorageUrl } from 'Firebase';
import { PostImage } from 'Post';

export const buildImageSourceSet = (images: PostImage[], ratio = 1): string => images.reduce((result, image) => {
	const url = createStorageUrl(image.path);
	return url !== null ? `${result}${result !== '' ? ', ' : ''}${url} ${Math.round(image.size.width * ratio)}w` : result;
}, '');
